import classNames from "classnames";
import Image, { ImageProps } from "next/image";
import { useEffect, useState } from "react";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import styles from "./next-image.module.scss";

interface INextImageProps extends ImageProps {
    src: string;
    alt: string;
    fallbackSrc?: string;
    className?: string;
    width?: number;
    height?: number;
}
function NextImage(props: INextImageProps) {
  const {
    src, alt, fallbackSrc, className = "", width, height, ...rest
  } = props;
  const [imgSrc, setImgSrc] = useState(src);

  useEffect(() => {
    setImgSrc(src);
  }, [src]);

  const handleImageError = () => {
    if (fallbackSrc) {
      setImgSrc(fallbackSrc);
    } else {
      setImgSrc(getRelativeImagePath("/images/common/image-not-available_16051144.png"));
    }
  };

  return (
    <Image
      src={imgSrc}
      alt={alt}
      width={width}
      height={height}
      onError={handleImageError}
      className={classNames(styles.next_image, {
        [className]: Boolean(className),
      })}
      {...rest}
    />
  );
}

export default NextImage;
